export default {
  ONE_HUNDRED: 100,
};
